import { useQueryStates } from "nuqs";
import type { ParserMap } from "nuqs";

/**
 * useQueryStates wrapper. Session storage persist/restore is handled centrally
 * in DataTableSearchProvider (all-or-nothing per path).
 */
export function usePersistedQueryStates(parsers, options) {
  return useQueryStates(parsers, options);
}